import debug from 'debug';
const log = debug('windcave-presubmit');

class WindcavePresubmit {
	constructor(element, options) {
		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;

		this.validationUrl = this.options.validationUrl;

		this.responseErrorElement = this.element.querySelector(
			this.options.responseErrorSelector
		);
		this.prefix = this.options.sitePrefix;
		this.sessionId = this.options.sessionId;

		this.init(options.isWatching);
	}

	init(isWatching) {
		if (!this.validationUrl) {
			log(
				`No validation URL provided: data-windcave-presubmit-validation-url="". Aborting...`
			);
			return false;
		}

		if (!this.responseErrorElement) {
			log(
				`No response error element found matching: "${this.options.responseErrorSelector}". Aborting...`
			);
			return false;
		}

		if (!this.sessionId) {
			log(
				`No session ID provided: data-windcave-presubmit-session-id="". Aborting...`
			);
			return false;
		}

		if (isWatching) {
			this.watch();
		}
	}

	watch() {
		this.element.addEventListener('submit', this.onFormSubmit.bind(this));
	}

	// Only called if isWatching is not false
	onFormSubmit(event) {
		log('onFormSubmit', event);
		event.preventDefault();
		this.responseErrorElement.hidden = true;
		this.requestValidation();
	}

	requestValidation() {
		const url = new URL(this.validationUrl, window.location.origin);
		url.searchParams.set('windcavesessionid', this.sessionId);
		url.searchParams.set('prefix', this.prefix);

		return fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
		})
			.then((response) => {
				if (response.ok) {
					return response.json();
				}
				return Promise.reject(response);
			})
			.then(this.onRequestSuccess.bind(this))
			.catch(this.onRequestError.bind(this));
	}

	onRequestSuccess(data) {
		log('onValidationSuccess', data);

		// data may contain an error message
		if (data !== true) {
			this.displayRequestError(data);
		}
	}

	onRequestError(error) {
		log('onValidationError');

		// This happens if the API call fails
		this.displayRequestError(error);
	}

	displayRequestError(errorMessage) {
		log('displayValidationError', errorMessage);

		this.responseErrorElement.hidden = false;

		if (this.options.onErrorEvent) {
			this.element.dispatchEvent(
				new CustomEvent(this.options.onErrorEvent, {
					bubbles: false,
					cancelable: true,
				})
			);
		}

		throw new Error(errorMessage);
	}
}

WindcavePresubmit.DEFAULTS = {
	responseErrorSelector: '[data-windcave-error]',
	onErrorEvent: false,
};

export default WindcavePresubmit;



// WEBPACK FOOTER //
// ./client/src/core/modules/windcave-presubmit/windcave-presubmit.js